import { readableColor } from 'polished';
import { colors } from '@ardoq/design-tokens';

export const readableButtonColor = (backgroundColor: string) =>
  readableColor(backgroundColor, colors.grey950, colors.white950);
